<nav class="header">
    <app-menu></app-menu>
</nav>
<div class="main">
	<router-outlet></router-outlet>
    <app-messages></app-messages>
</div>
<footer class="brand">
    <img class="brand_logo" src="../assets/images/Logo-DerivatiK.png" alt="Derivatik">
</footer>